module.exports = __webpack_public_path__ + "img/endIlustration.a0006593.png";